import { BlazeError } from '@blaze-cms/core-errors';
import { getDynamicMutation } from '../../application';

const updateEntityRecord = async (client, entitySchema, input) => {
  const mutation = getDynamicMutation('UPDATE_ENTITY_MUTATION')(entitySchema);

  const { data } = await client.mutate({
    mutation,
    variables: { input }
  });

  const result = data?.updateEntity?.result;
  if (!result) {
    throw new BlazeError('Update entity mutation did not return the updated record');
  }

  return result;
};

export default updateEntityRecord;
